export enum AnalyticType {
  SUGAR_CONTENT_PREDICTION = 'sat-sugarcontent',
  SUGAR_CONTENT_YIELD = 'sat-sugaryield',
  VEGETATIVE_INDEX = 'vegetative-index'
}
